export const screenBreakpointValues = {
  xs: "425px",
  sm: "769px",
  md: "1025px",
  lg: "1281px",
  xl: "1600px",
}